import styled from 'foundations-theming/utils';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const Viewport = styled.div.withConfig({
  displayName: "ContentViewport__Viewport"
})(({
  minHeight,
  padding,
  position,
  backgroundColor,
  color,
  background,
  textAlign
}) => ({
  height: '100%',
  width: '100%',
  padding,
  minHeight,
  position,
  backgroundColor,
  color,
  background,
  textAlign
}));
const ContentViewport = ({
  children,
  viewportStyles
}) => /*#__PURE__*/_jsx(View, {
  padding: "0",
  children: /*#__PURE__*/_jsx(Viewport, Object.assign({}, viewportStyles, {
    children: children
  }))
});
export default ContentViewport;